/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import './DownloadFileProgress.scss';

import { DownloadingProgressBar } from '../../../components/ProgressIndicator';

const Ellipsis = ({ current }) => (
  <>
    <i style={{ opacity: 1 }}>.</i>
    <i style={{ opacity: current > 1 ? 1 : 0 }}>.</i>
    <i style={{ opacity: current >= 2 ? 1 : 0 }}>.</i>
  </>
);

const DownloadFileProgress = (props) => {
  const { isDownloading, isVisible, isDone, isError, style } = props;

  const animationInterval = React.useRef(null);
  const progressInterval = React.useRef(null);
  const [ellipseCount, setEllipseCount] = React.useState(0);
  const [progress, setProgress] = React.useState(0);

  React.useEffect(() => {
    if (isDone) {
      setProgress(100);
    } else {
      setProgress(0);
    }
  }, [isDone]);

  React.useEffect(() => {
    const animateEllipsis = () => {
      setEllipseCount(ellipseCount >= 3 ? 0 : ellipseCount + 1);
    };
    const incrementProgress = () => {
      setProgress(progress + 5);
    };

    if (isDownloading) {
      animationInterval.current = setInterval(animateEllipsis, 500);
      progressInterval.current = setInterval(incrementProgress, 300);
    } else {
      if (progressInterval.current) {
        clearInterval(progressInterval.current);
        progressInterval.current = null;
      }
    }

    return () => {
      if (animationInterval.current) {
        clearInterval(animationInterval.current);
        animationInterval.current = null;
      }
      if (progressInterval.current) {
        clearInterval(progressInterval.current);
        progressInterval.current = null;
      }
    };
  }, [isDownloading]);

  const isShowing = isVisible && (isError || isDone || isDownloading);

  return (
    <div className="cmp-downloadfileprogress" style={style}>
      {
        isShowing ? (
          <>
            {
              isError ? (
                <div className="__box font-footnote animate">
                  <FormattedMessage id="error.downloadAndroid.message" />
                </div>
              ) : isDone ? (
                <div className="__box font-footnote animate">
                  <FormattedMessage id="download.confirmAndroid.message.text" />
                </div>
              ) : isDownloading ? (
                <div className="__box font-footnote">
                  <FormattedMessage id="download.progressAndroid.message.text" />
                  <Ellipsis current={ellipseCount} />
                </div>
              ) : null
            }
            <DownloadingProgressBar
              progress={progress}
              totalTime={300}
              style={{ position: 'absolute', width: '100%', bottom: -17 }}
            />
          </>
        ) : null
      }
    </div>
  );
};

export default DownloadFileProgress;
